/****----COMMON----****/
import Utility from './components/utility/wrapper';
/****----COMPONENTS----****/
import Sticky from './components/sticky/wrapper';
import UmbracoForms from './components/umbracoForms/wrapper';
import Carousel from './components/carousel/wrapper';
import FeedGridController from '../app_plugins/Feed/feedGrid.controller';
import FeedResource from '../app_plugins/Feed/feedResource.factory';
import SearchController from '../app_plugins/Search/search.controller';
import SearchResource from '../app_plugins/Search/searchResource.factory';
import VideoWrapper from '../app_plugins/VideoEmbedder/js/wrapper';
import DataOpenDirective from '../app_plugins/LazyModals/data-open.directive';
import ModalLoaderDirective from '../app_plugins/LazyModals/modal-loader.directive';
import MultiCheckbox from './components/multiCheckbox/multi-checkbox.component';
import ReviewsController from './components/reviews/reviews.controller';
import StarsComponent from './components/stars/stars.component';
import LocationSearchComponent from './components/locationSearch/location-search.component';
import CheckboxDropdownComponent from './components/checkboxDropdown/checkbox-dropdown.component';
import DealerSearchController from '../scripts/widgets/dealer-search.controller';
import GoogleMapComponent from './components/googleMap/google-map-component';
import ProductSelectorComponent from './components/formFields/product-selector.component';
import DistributorSelectorComponent from './components/formFields/distributor-selector.component';
import ProductResource from '../app_plugins/Products/productResource.factory';

export default function App() {
    var module = 'app';
    angular.module('app', [])
        .config(config)
        .run(run);

    run.$inject = [];
    function run() {

    }

    config.$inject = ['$locationProvider'];
    function config($locationProvider) {
        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false,
            rewriteLinks: false
        });
    }
    Utility(module);
    ReviewsController(module);
    StarsComponent(module);
    DataOpenDirective(module);
    ModalLoaderDirective(module);
    VideoWrapper(module);
    Sticky(module);
    Carousel(module);
    MultiCheckbox(module);
    UmbracoForms(module);
    FeedResource(module);
    FeedGridController(module);
    SearchResource(module);
    SearchController(module);
    LocationSearchComponent(module);
    CheckboxDropdownComponent(module);
    GoogleMapComponent(module);
    DealerSearchController(module);
    ProductSelectorComponent(module);
    DistributorSelectorComponent(module);
    ProductResource(module);

    angular.bootstrap(document, ['app']);
}